/* Delfino — datasetul quiz-ului „Construim împreună pachetul" (8 trasee × 5 întrebări).
   Copiat verbatim din source/live-supl/dom/home/_inline-18.js; singurele modificări:
   - PRODUCTS[].img → numele asset-ului local (imaginile live, descărcate de tools/copy-images.mjs);
   - PRODUCTS[].url → handle-urile reale din magazin pentru Matrix și Ulei fungic, restul
     /collections/all (produsele respective nu sunt încă în Shopify). Când un bloc „Problemă" din
     secțiunea quiz-banner are un produs ales, harta din <script data-dl-quiz-products> îl
     suprascrie — vezi theme/assets/quiz.js.
   Se exportă ca window.DLQuizData (globalThis în Node, ca să poată fi testat fără browser). */
(function (root) {
  'use strict';

  /* ──────────────────────────────────────────────────────────────
     Quiz dataset — 8 problem paths × 5 questions each.
     Voice: empathic, "vecină din Sibiu", default pronoun "tu".
     ──────────────────────────────────────────────────────────── */
  var ALL_PROBLEMS = [
    { key: 'ciuperca',    label: 'Ciuperca unghiei',                    icon: '🦶' },
    { key: 'articulatii', label: 'Dureri articulare',                   icon: '🦴' },
    { key: 'cervicala',   label: 'Tensiune cervicală',                  icon: '💆' },
    { key: 'spate',       label: 'Spate slăbit, postură proastă',       icon: '🧍' },
    { key: 'genunchi',    label: 'Genunchi sensibili la efort',         icon: '🦵' },
    { key: 'picioare',    label: 'Picioare obosite, circulație lentă',  icon: '🚶' },
    { key: 'somn',        label: 'Somn agitat, eliminare lentă',        icon: '🌙' },
    { key: 'frumusete',   label: 'Păr fragil, unghii moi, piele uscată', icon: '✦' }
  ];

  /* Map of recommended product per problem key (used both for the result page
     of that path AND for cross-sell hints when another path's user picks it). */
  var PRODUCTS = {
    'ciuperca':    { title: 'Ulei Fungic Delfino', price: '169 lei', protocol: '2 picături dimineața + seara, pe unghie curată. Protocol 28 zile.', img: 'img-x-20260427_133057_821433108708274c_hero.webp', url: '/products/ulei-pentru-ciuperca-fungica-defino®' },
    'articulatii': { title: 'Matrix 4-Colagen + Plasturi Balsam de Tigru', price: 'de la 179 lei', protocol: '25 ml de Matrix dimineața. Plasturi seara, pe punctul dureros — 12 ore aplicate, 12 fără.', img: 'img-x-20260427_133101_1ea987946c843955_hero.webp', url: '/products/matrix-4-colagen-lichid-delfino®️' },
    'cervicala':   { title: 'Aparat masaj cervical Delfino', price: '219 lei', protocol: '10–15 min, modul cald + vibrație ușoară, înainte de culcare.', img: 'img-live-828f00dc.webp', url: '/collections/all' },
    'spate':       { title: 'Centură lombară Delfino', price: '149 lei', protocol: 'Pe sub bluză, 4–6 ore pe zi, în zilele cu solicitare. Nu se poartă continuu.', img: 'img-live-9ff93ca4.webp', url: '/collections/all' },
    'genunchi':    { title: 'Genunchieră compresivă Delfino', price: '89 lei', protocol: 'În zilele cu efort sau recuperare. Compresia o reglezi după senzație.', img: 'img-live-e498b0f4.webp', url: '/collections/all' },
    'picioare':    { title: 'Spa Ionic Delfino', price: '349 lei', protocol: '20–25 minute seara, apă caldă + sare. 3–4 ședințe pe săptămână.', img: 'img-live-33de6c15.webp', url: '/collections/all' },
    'somn':        { title: 'Plasturi detox Delfino', price: '65 lei (20 buc.)', protocol: 'Seara, pe tălpi curate. 1 plasture / noapte, cură de 10–14 zile cu pauze.', img: 'img-live-f0781380.webp', url: '/collections/all' },
    'frumusete':   { title: 'Matrix 4-Colagen 500ml', price: '179 lei', protocol: '25 ml/zi dimineața, înainte de prima masă. Cură minimă: 30 zile.', img: 'img-x-20260427_133101_1ea987946c843955_hero.webp', url: '/products/matrix-4-colagen-lichid-delfino®️' }
  };

  /* Each path: 5 questions, optional micro-validation after Q1/Q2,
     plus a result block with a customer quote in brand voice. */
  var QUIZ = {
    'ciuperca': {
      questions: [
        {
          type: 'single',
          prompt: 'Spune-mi cum arată azi — fii sinceră, nimic nu e prea mult de zis.',
          options: [
            'Doar o pată albă, dar mă uit zilnic și văd că se mărește',
            'Mai multe unghii — m-am ascuns la plajă, nu mai port sandale',
            'Una s-a despicat sau ridicat — trec de etapa cosmetică, mă doare'
          ],
          validation: 'Înțeleg. La etapa asta nu e prea târziu — dar e momentul potrivit să începi.'
        },
        {
          type: 'single',
          prompt: 'De când te lupți cu asta?',
          helper: 'Mă ajută să-ți spun realist cât durează protocolul.',
          options: [
            'De câteva săptămâni — am observat-o de curând',
            'De câteva luni — am încercat și gel, și pilă, și răbdare',
            'Mai mult de jumătate de an — mă obișnuisem, dar gata',
            'Apare și dispare — a treia oară când o tratez'
          ],
          validation: '«A treia oară» e o frază pe care o auzim săptămânal. De data asta îți promit că merge — dacă faci protocolul cum trebuie.'
        },
        {
          type: 'single',
          prompt: 'Când o vezi cel mai des în ziua ta?',
          options: [
            'La duș, când mă spăl pe picioare',
            'Seara, când scot pantofii',
            'După sport sau plimbări lungi',
            'În fiecare moment când îmi văd unghia'
          ]
        },
        {
          type: 'multi',
          prompt: 'Ai și asta?',
          helper: 'Câteodată ciuperca vine la pachet cu alte semne. Spune-mi tot ce vezi — îmi ajută să-ți potrivesc protocolul.',
          options: [
            'Cuticule fragile sau crăpate',
            'Pete albe punctuale (nu pe toată unghia)',
            'Unghii care se despică ușor',
            'Piele iritată sau crăpată în jurul unghiei',
            'Mâncărime între degete',
            'Niciuna — doar unghia'
          ]
        },
        {
          type: 'cross',
          prompt: 'Mai e ceva ce te-ar fi întrebat și mama?',
          helper: 'Bifează tot ce te mai supără. Poate avem ceva și pentru asta.'
        }
      ],
      result: {
        preface: 'Mulțumesc. Citesc răspunsurile tale și înțeleg exact prin ce treci.',
        pitch: 'Pentru tine recomand <strong>Ulei Fungic Delfino</strong>. E același pe care Mariana din Sibiu îl folosește de 3 ani.',
        quote: { text: 'La 14 zile am văzut diferența. La 28 nu mai aveam ce trata.', author: 'Mariana, 47 ani · Sibiu' }
      }
    },

    'articulatii': {
      questions: [
        {
          type: 'single',
          prompt: 'Spune-mi cum sunt durerile azi.',
          options: [
            'Doar dimineața, până mă mișc — apoi se mai duc',
            'Aproape zilnic, îmi limitează ce fac',
            'Tot timpul — abia mai dorm bine din cauza lor'
          ],
          validation: 'Te înțeleg. Durerea care îți rupe somnul e altă categorie — știu exact ce să-ți dau.'
        },
        {
          type: 'single',
          prompt: 'De când te lupți cu ele?',
          options: [
            'De câteva săptămâni — au apărut recent',
            'De luni — nu mai zic «o să treacă»',
            'De peste un an — am încercat paracetamol, unguent, răbdare',
            'Cronic — știu deja diagnosticul'
          ],
          validation: 'Asta nu se rezolvă într-o săptămână. Dar pe 60 de zile vei simți altă diferență.'
        },
        {
          type: 'single',
          prompt: 'Când te dor cel mai mult?',
          options: [
            'Dimineața, până mă mișc 30 minute',
            'După efort fizic / sport',
            'Iarna sau pe vreme schimbătoare',
            'Tot timpul, fără un pattern'
          ]
        },
        {
          type: 'multi',
          prompt: 'Ai și asta?',
          helper: 'Mai multe semne mă ajută să combin produsele potrivite — uneori articulațiile cer ceva în interior și ceva pe afară.',
          options: [
            'Genunchi care scârțâie când urc scări',
            'Articulații de la degete care înțepenesc',
            'Sensibilitate la atingere',
            'Umflătură vizibilă',
            'Pielea fierbinte sau roșie deasupra durerii',
            'Doar durerea, nimic vizibil'
          ]
        },
        {
          type: 'cross',
          prompt: 'Mai e ceva ce te macină?',
          helper: 'Bifează tot — mulți au mai multe lucruri legate între ele.'
        }
      ],
      result: {
        preface: 'Te aud. Articulațiile sunt zilnic în treaba ta — îți recomand un protocol din interior și unul pentru calmare locală.',
        pitch: 'Pentru tine recomand <strong>Matrix 4-Colagen 500ml</strong> dimineața + <strong>Plasturi Balsam de Tigru</strong> seara, pe punctul cel mai dureros.',
        quote: { text: 'Am 52 de ani, am început Matrix după ce nu mai puteam să închei un nasture. La 6 săptămâni — diferență vizibilă pe degete și genunchi.', author: 'Elena, 52 ani · Brașov' }
      }
    },

    'cervicala': {
      questions: [
        {
          type: 'single',
          prompt: 'Cum simți acum gâtul și umerii?',
          options: [
            'Doar la final de zi — aș vrea o pauză',
            'Apare zilnic, mă enervează',
            'Constant — mă doare și capul de la el'
          ],
          validation: 'Cefaleea care vine din ceafă e clasică — și se rezolvă odată ce relaxezi trapezul. O facem.'
        },
        {
          type: 'single',
          prompt: 'De cât timp e așa?',
          options: [
            'O săptămână-două',
            'De luni — am început să dorm prost din cauza ei',
            'Cronic — știu deja că vine din birou / poziție'
          ],
          validation: 'Nu ești singura — la noi 4 din 10 cliente lucrează la calculator peste 8h/zi.'
        },
        {
          type: 'single',
          prompt: 'Când o simți cel mai tare?',
          options: [
            'După 4–6 ore la calculator / telefon',
            'După condus',
            'După nopți cu somn prost',
            'Mereu, indiferent ce fac'
          ]
        },
        {
          type: 'multi',
          prompt: 'Ai și asta?',
          helper: 'Tensiunea cervicală nu vine niciodată singură. Spune-mi tot ce simți.',
          options: [
            'Dureri de cap care urcă din ceafă',
            'Trapez tare, încordat',
            'Pocnituri când rotesc gâtul',
            'Furnicături într-un braț',
            'Probleme de concentrare în zilele rele',
            'Doar tensiune, fără alte semne'
          ]
        },
        { type: 'cross', prompt: 'Mai e ceva ce ai vrea să rezolvăm?', helper: 'Bifează tot — caut combinația care îți face cel mai bine.' }
      ],
      result: {
        preface: 'OK. Pentru tensiunea de la birou ai nevoie de relaxare locală cu un dispozitiv care chiar lucrează mușchiul, nu doar îl masează superficial.',
        pitch: 'Recomand <strong>Aparatul de masaj cervical Delfino</strong>. 10–15 minute seara, pe modul cald + vibrație ușoară, înainte de culcare.',
        quote: { text: 'Am stat 8 ore pe zi pe Zoom. Aparatul ăsta mi-a dat înapoi serile fără cap greu.', author: 'Ana, 38 ani · București' }
      }
    },

    'spate': {
      questions: [
        {
          type: 'single',
          prompt: 'Cum se manifestă?',
          options: [
            'Mă cocoșesc fără să vreau — mi-au atras atenția cei din jur',
            'Mă doare partea de jos a spatelui după o zi întreagă',
            'Nu pot sta mult în picioare fără să mă sprijin'
          ],
          validation: 'Postura proastă nu e despre voință — e despre mușchi care nu mai țin. Asta se antrenează.'
        },
        {
          type: 'single',
          prompt: 'De când e așa?',
          options: [
            'E nou, am observat de curând',
            'De câteva luni — mai ales după sarcină / job nou',
            'Ani buni — vechi cunoștințe',
            'După un episod acut (lumbago, hernie)'
          ],
          validation: 'Mulți încep cu o centură DOAR pe perioadele grele și-și recuperează spatele în săptămâni.'
        },
        {
          type: 'single',
          prompt: 'Când te doare cel mai des?',
          options: [
            'La birou, după 3–4 ore șezut',
            'În picioare la magazin / muncă',
            'După ridicat copil / sacoșe grele',
            'Toată ziua, fără pauză'
          ]
        },
        {
          type: 'multi',
          prompt: 'Ai și asta?',
          helper: 'Spatele lucrează cu pelvisul și abdomenul — orice semn în plus mă ajută să combin centura cu altceva.',
          options: [
            'Furnicături în picioare',
            'Senzație de „arsură" în partea de jos a spatelui',
            'Spasme musculare ocazionale',
            'Greutate în pelvis',
            'Sciatică (durerea coboară pe picior)',
            'Doar postură proastă, fără durere'
          ]
        },
        { type: 'cross', prompt: 'Și ultima — ce mai vrei să rezolvi?', helper: 'Bifează tot, ca să-ți pot face un plan complet.' }
      ],
      result: {
        preface: 'Înțeleg. Centura nu e tratament — e o cârjă bună pentru zilele grele, până când mușchii recuperează singuri.',
        pitch: 'Recomand <strong>Centura lombară Delfino</strong>. Pe sub bluză, 4–6 ore în zilele cu solicitare. Nu o porți continuu — vrem să-ți antrenăm spatele, nu să-l obișnuim cu sprijin.',
        quote: { text: 'După nașterea celui de-al doilea copil, era prima dată când puteam sta în picioare la bucătărie peste o oră fără să gem.', author: 'Ioana, 34 ani · Cluj' }
      }
    },

    'genunchi': {
      questions: [
        {
          type: 'single',
          prompt: 'Cum sunt genunchii azi?',
          options: [
            'Doar când urc / cobor scări',
            'Și la mers normal',
            'Mă trezesc cu ei umflați'
          ],
          validation: 'Genunchii care se umflă peste noapte au nevoie de compresie graduală, nu de odihnă pură. Te scot din pat altfel.'
        },
        {
          type: 'single',
          prompt: 'De când îți fac probleme?',
          options: [
            'De curând, după un efort',
            'De luni',
            'Cronic, după accidentare / artroză diagnosticată'
          ]
        },
        {
          type: 'single',
          prompt: 'Când îi simți cel mai mult?',
          options: [
            'La sport / alergare',
            'Când mă ridic după ce am stat',
            'Pe vreme rece / umedă',
            'Fără pattern, mereu'
          ]
        },
        {
          type: 'multi',
          prompt: 'Ai și asta?',
          helper: 'Articulația genunchiului are mai multe componente — un singur semn în plus poate schimba ce-ți recomand.',
          options: [
            'Pocniri când îndoi genunchiul',
            'Apă în articulație (umflătură moale)',
            'Nu pot îndoi complet',
            'Tremurat când stau în picioare prelung',
            'Ambii genunchi, simetric',
            'Doar disconfort, nu durere acută'
          ]
        },
        { type: 'cross', prompt: 'Mai e ceva ce mă lași să rezolv?', helper: 'Bifează tot — combinația contează.' }
      ],
      result: {
        preface: 'Bine. Pentru genunchi ne trebuie compresie corectă, nu strânsă forțat. Asta dă stabilitate fără să blocheze articulația.',
        pitch: 'Recomand <strong>Genunchierea compresivă Delfino</strong>. În zilele cu efort sau recuperare. Compresia o reglezi după senzație — niciodată să te înțepe.',
        quote: { text: 'Am alergat un semimaraton cu ea. Pentru prima dată în 3 ani, fără gheață pe genunchi seara.', author: 'Andrei, 41 ani · Sibiu' }
      }
    },

    'picioare': {
      questions: [
        {
          type: 'single',
          prompt: 'Cum sunt picioarele tale seara?',
          options: [
            'Doar obosite, după o zi în picioare',
            'Aproape zilnic simt greutatea',
            'Le văd umflate / venele ies vizibil'
          ],
          validation: 'Greutatea aia de seara nu e «de la oboseală» — e circulație care s-a încetinit. Se relansează.'
        },
        {
          type: 'single',
          prompt: 'De când e așa?',
          options: [
            'De ultimele luni',
            'De ani buni',
            'Cronic — am varice / probleme circulatorii diagnosticate'
          ]
        },
        {
          type: 'single',
          prompt: 'Când le simți cel mai tare?',
          options: [
            'După stat în picioare',
            'După stat la birou ore lungi',
            'Pe căldură / vară',
            'Mereu'
          ]
        },
        {
          type: 'multi',
          prompt: 'Ai și asta?',
          helper: 'Circulația și retenția vorbesc împreună — semnele astea îmi spun ce să combin.',
          options: [
            'Vene proeminente la gambă / pulpă',
            'Crampe nocturne',
            'Senzație de furnicături',
            'Picioare reci constant',
            'Glezne umflate seara',
            'Doar oboseală, nimic vizibil'
          ]
        },
        { type: 'cross', prompt: 'Și ultima — ce te mai supără?', helper: 'Bifează tot ce vrei să rezolvăm împreună.' }
      ],
      result: {
        preface: 'OK. Pentru circulație ai nevoie de o rutină de seară care chiar relaxează — nu doar să stai cu picioarele sus.',
        pitch: 'Recomand <strong>Spa Ionic Delfino</strong>. 20–25 minute seara, apă caldă + sare. 3–4 ședințe pe săptămână.',
        quote: { text: 'Pentru prima dată după 5 ani, mi-am scos pantofii la 22:00 și nu mi-am mai pus mâinile pe glezne. Așa simplu.', author: 'Mirela, 56 ani · Timișoara' }
      }
    },

    'somn': {
      questions: [
        {
          type: 'single',
          prompt: 'Cum dormi acum?',
          options: [
            'Adorm greu, dar dorm tun',
            'Mă trezesc de 2–3 ori pe noapte',
            'Mă scol mai obosită decât m-am culcat'
          ],
          validation: 'Trezirile de la 3–4 dimineața au și ele un pattern — și asta intră în plan.'
        },
        {
          type: 'single',
          prompt: 'De când e așa?',
          options: [
            'De câteva săptămâni',
            'De luni — am început să mă bazez pe cafea',
            'Cronic, ani de zile'
          ]
        },
        {
          type: 'single',
          prompt: 'Când e cel mai prost?',
          options: [
            'În săptămânile cu stres',
            'După mese târzii',
            'Pe perioade fără pattern',
            'Mereu'
          ]
        },
        {
          type: 'multi',
          prompt: 'Ai și asta?',
          helper: 'Somnul e adesea legat de eliminare și inflamație — îmi spune ce să adaug în plan.',
          options: [
            'Balonare și disconfort dimineața',
            'Tranzit lent (nu zilnic)',
            'Senzație de „greutate" generalizată',
            'Pielea palidă / cu acnee',
            'Greutate în zona ficatului',
            'Doar somnul, nimic la digestie'
          ]
        },
        { type: 'cross', prompt: 'Și ultima — ce mai poartă-n cap?', helper: 'Bifează tot. Detoxul atinge mai multe lucruri deodată.' }
      ],
      result: {
        preface: 'Te aud. Somnul prost și tranzitul lent vorbesc între ele — îți pun ceva care lucrează exact pe interfața asta.',
        pitch: 'Recomand <strong>Plasturii detox Delfino</strong>. Seara, pe tălpi curate. 1 plasture / noapte, cură de 10–14 zile cu pauze.',
        quote: { text: 'Aplic seara, dorm până dimineața, dimineața mă scol fără greutatea aia ca de bilă. Cumpăr a treia oară.', author: 'Camelia, 44 ani · Iași' }
      }
    },

    'frumusete': {
      questions: [
        {
          type: 'single',
          prompt: 'Ce vezi tu în oglindă?',
          options: [
            'Văd că nu mai e ca acum 1–2 ani',
            'Pierd vizibil păr / unghiile se rup repede',
            'Toate trei se schimbă: păr, unghii, piele'
          ],
          validation: 'Schimbarea asta nu e «vârsta» — e colagen care scade din 25 de ani. Se înlocuiește.'
        },
        {
          type: 'single',
          prompt: 'De când observi diferența?',
          options: [
            'De câteva luni',
            'De peste un an',
            'Postpartum / postsarcină',
            'Cronic, mereu'
          ]
        },
        {
          type: 'single',
          prompt: 'Când e cel mai vizibil?',
          options: [
            'Mai ales primăvara / toamna (sezonier)',
            'După dietă / restricții',
            'După stres prelungit',
            'Fără un pattern clar'
          ]
        },
        {
          type: 'multi',
          prompt: 'Ai și asta?',
          helper: 'Colagenul lucrează diferit pe păr, unghii și piele — îmi spui ce simți cel mai mult.',
          options: [
            'Părul cade vizibil la pieptănat',
            'Unghii striate / cu pete',
            'Piele uscată în plus față de altă dată',
            'Tenul mai opac, fără strălucire',
            'Cuticule care se desprind ușor',
            'Doar unul din ele'
          ]
        },
        { type: 'cross', prompt: 'Și ultima — ce mai ai în minte să rezolvăm?', helper: 'Bifează tot.' }
      ],
      result: {
        preface: 'Te înțeleg. Colagenul lichid e diferit de capsule — se absoarbe mai repede și începi să simți diferența mai devreme.',
        pitch: 'Recomand <strong>Matrix 4-Colagen 500ml</strong>. 25 ml/zi dimineața, înainte de prima masă. Cură minimă: 30 zile.',
        quote: { text: 'La 4 săptămâni, prima diferență — unghiile. La 8 — părul. La 12 — pielea de pe dosul mâinii e altă piele.', author: 'Cristina, 49 ani · Constanța' }
      }
    }
  };

  root.DLQuizData = { ALL_PROBLEMS: ALL_PROBLEMS, PRODUCTS: PRODUCTS, QUIZ: QUIZ };
})(typeof window === 'undefined' ? globalThis : window);
